import { createStore } from "vuex";
import { mainModule } from "./mainModule";
import { pageModule } from "./pageModule";
import { favoritesModule } from "./favoritesModule";

export default createStore({
  modules: {
    main: mainModule,
    page: pageModule,
    favorites: favoritesModule,
  }
})